import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import {
  SFSlideThumbnail,
  SFTypography,
  SFStack,
  SFUseStyled,
  //   SFIcons,
  SFToggleButtons,
} from "@sf-core";
import getStatusBadge from "../../constants/statusBadgeMappings";
import { getSkillPathUrl } from "../../constants/urls";
import { SFHelpers } from "@sf-core";
import { getThumbnailForSkillpath } from "../../helpers/getThumbnailFunction";
import { skillPathPageActions } from "../../redux/reducers/skillPathPageReducer";
import { useDispatch } from "react-redux";

const { styled } = SFUseStyled();

const CourseDetailStackStyled = styled(SFStack)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  position: "relative",
  "& .course-details-button-container": {
    display: "none",
  },
  "&:hover .course-details-button-container": {
    display: "flex",
  },
  width: "100%",
}));

const CourseContainerStackStyled = styled(SFStack)(({ theme }) => ({
  "&:focus-within .course-details-button-container": {
    display: "flex",
  },
}));

const StyledTypography = styled(SFTypography, {
  shouldForwardProp: (prop) => prop !== "lines",
})(({ theme, lines }) => ({
  overflow: "hidden",
  wordWrap: "break-word",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: `calc(${lines})`,
  lineClamp: `calc(${lines})`,
  WebkitBoxOrient: "vertical",
  p: {
    margin: 0,
  },
}));

const SkillPathItem = ({ skillPath, descriptionLines }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();  
  const dispatch = useDispatch();
  const location = useLocation();

  const handleThumbnailClick = () => {
    dispatch(
      skillPathPageActions.setState({
        skillPathId: skillPath.id,
        domainId: skillPath.domainId,
        domainName: skillPath.domainName,
        domainTypeId: skillPath.domainTypeId,
        domainStatus: skillPath.domainStatus,
      })
    );
    navigate(getSkillPathUrl(skillPath.id), {
      state: { previousLoc: location.pathname },
    });
  };

  return (
    <>
      <CourseContainerStackStyled
        direction="row"
        spacing={2}
        id={`skill-paths-${skillPath.id}`}
      >
        <>
          <SFSlideThumbnail
            className="video-button"
            onClick={handleThumbnailClick}
            // Change the mock skill path image to the actual thumbnail
            image={getThumbnailForSkillpath(skillPath.id)}
            badge={getStatusBadge(skillPath.status, t)}
          />
          <SFStack direction="column" style={{ width: "100%" }}>
            <CourseDetailStackStyled spacing={1.5}>
              <StyledTypography
                variant="courseCarouselTitle"
                lines={2}
                component="h2"
              >
                {skillPath.name}
              </StyledTypography>
              <StyledTypography variant="body1" lines={descriptionLines}>
                {skillPath.description}
              </StyledTypography>
              {skillPath.skills?.length > 0 && (
                <SFToggleButtons
                  size="small"
                  disabled={true}
                  haveCollapsibleItems={true}
                  key={skillPath.id}
                  items={skillPath.skills.map((x) => ({
                    label: x.name,
                    value: x.id,
                  }))}
                  noHover
                />
              )}
            </CourseDetailStackStyled>
            <SFTypography variant="body1">
              {t("lxpComponents.skillPaths.skillPathsDuration", {
                totalDuration: SFHelpers.DurationFormatter(
                  skillPath.totalDuration,
                  SFHelpers.DurationFormatterOptions.ALL_UNITS
                ),
                totalCourses: skillPath.totalCourses,
              })}
            </SFTypography>
          </SFStack>
        </>
      </CourseContainerStackStyled>
    </>
  );
};

export default SkillPathItem;
